import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {
 // Collapse,
  Navbar,
 // NavbarToggler,
 // Nav,
 // NavItem,
  //UncontrolledDropdown,
 // DropdownToggle,
 // DropdownMenu,
 // DropdownItem,
 // NavLink 
} from 'reactstrap';
import Dialog from 'material-ui/Dialog';
import urlBase from '../url-base';
import axios from 'axios';
import moment from 'moment';

import {
   Container, 
   //Row, Col, Button
} from 'reactstrap';


class MenuNew extends React.Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);

    this.state = {
      isOpen: false,
      aboutDentalModalOpen: false,

      showBlackFriday: false,
      showBannerBoleto: true,
      dfcontadordias: '00',
      dfcontadorhoras: '00',
      dfcontadormin: '00',
      currentTimeServer: '',
      interval: null,
      setOnLoad: false,
    };

    window.onresize = function() {
      this.blackfriday();
    }.bind(this);

    this.styles = {
      menu: {
        backgroundColor: '#fff',
      },
      logo: {
        backgroundImage:  'url(' + require('../assets/images/logo.png') + ')',
        backgroundSize:'100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        height: 90,
        width: 165,
        float: 'left'
      }
    };
  }


  componentDidMount() {
    // Quando não for a página de 
    /* if (!window.location.href.includes('formmakeyourplan')) {
      this.timeBlackFriday();

      let state = this.state;
      state.interval = setInterval(function () {
        this.timeBlackFriday();
      }.bind(this), 60000);

      this.setState(state);
    } */
  }

  componentWillUnmount() {
    clearInterval(this.state.interval);
  }

  timeBlackFriday() {
    axios.post(urlBase.loopBack + 'Sales/currentTime')
    .then((response) => {
      moment.locale('pt-BR');
      let end = moment([2019, 11, 31, 23, 59]);
      let now = moment([
        response.data.year,
        response.data.month-1,
        response.data.day,
        response.data.hours,
        response.data.minutes,
        response.data.seconds
      ]);

      if (end.diff(now) > 0) {
        let state = this.state;
        state.showBlackFriday = true;
        state.currentTimeServer = response.data;
        let duration = moment.duration(end.diff(now));
  
        state.dfcontadordias = duration.get('days');
        state.dfcontadorhoras = duration.get('hours');
        state.dfcontadormin = duration.get('minutes');
  
        if (state.dfcontadordias < 10)
          state.dfcontadordias = '0'+state.dfcontadordias;
        if (state.dfcontadorhoras < 10)
          state.dfcontadorhoras = '0'+state.dfcontadorhoras;
        if (state.dfcontadormin < 10)
          state.dfcontadormin = '0'+state.dfcontadormin;
  
        if (state.setOnLoad == false) {
          state.setOnLoad = true;
          const img = new Image();
          img.onload =() => {
            this.blackfriday();
          };
    
          img.src = urlBase.client+'assets/images2/blackfriday/fundo_banner_horizontal.png';
        }

        this.setState(this.state);
      }
      else {
        let state = this.state;
        state.showBlackFriday = false;
        this.setState(this.state);
      }
    })
    .catch(function () {
      alert('Erro ao pegar data do servidor');
    });
  }
  
  blackfriday() {
    if (window.innerWidth > 500) {
      document.getElementById('imgblackfriday').style.width = '100%';
      document.getElementById("imgblackfriday").src = urlBase.client+'assets/images2/blackfriday/fundo_banner_horizontal.png';
      let fontSize = (document.getElementById("blackfriday").offsetHeight * 18.76)/100;
      let letterSpacing = '';
      let marginLeft = (document.getElementById("blackfriday").offsetHeight * 4.02)/100;

      // Para FireFox
      if (typeof InstallTrigger !== 'undefined') {
        letterSpacing = (document.getElementById("blackfriday").offsetHeight * 1.87)/100;
      }
      else
        letterSpacing = (document.getElementById("blackfriday").offsetHeight * 3.21)/100;

      document.getElementById('bfcontador').style.fontSize = fontSize+'px';
      document.getElementById('bfcontador').style.letterSpacing = letterSpacing+'px';
      document.getElementById('dfcontadordias').style.marginLeft = marginLeft+'px';
      document.getElementById('bfcontador').style.top = '14%';
      document.getElementById('bfcontador').style.left = '50%';
    }
    else {
      document.getElementById('imgblackfriday').style.width = window.innerWidth+'px';
      document.getElementById("imgblackfriday").src = urlBase.client+'assets/images2/blackfriday/fundo_banner_vertical.png';

      let fontSize = (document.getElementById("blackfriday").offsetWidth * 17)/100;
      let letterSpacing = '';
      let marginLeft = (document.getElementById("blackfriday").offsetWidth * 1.09)/100;

      // Para FireFox
      if (typeof InstallTrigger !== 'undefined') {
        letterSpacing = (document.getElementById("blackfriday").offsetHeight * 2.4)/100;
      }
      else
        letterSpacing = (document.getElementById("blackfriday").offsetWidth * 5)/100;

      document.getElementById('bfcontador').style.fontSize = fontSize+'px';
      document.getElementById('bfcontador').style.letterSpacing = letterSpacing+'px';
      document.getElementById('dfcontadordias').style.marginLeft = marginLeft+'px';
      document.getElementById('bfcontador').style.top = '11.5%';
      document.getElementById('bfcontador').style.left = '51%';
    }
  }

  setValuePlan(id, payment, type) {
    localStorage.setItem("dental_plan", id);
    localStorage.setItem("payment_plan", payment);
    localStorage.setItem("type_plan", type);

    window.location.href = urlBase.client + 'formmakeyourplan';
  }

  closeBlackFriday() {
    let state = this.state;
    state.showBlackFriday = false;
    this.setState(state);
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  aboutDentalModal() {
    let state = this.state;
    state.aboutDentalModalOpen = true;
    this.setState(state);
  }
  
  aboutDentalModalClose() {
    this.setState({ aboutDentalModalOpen: false });
  }

  render() {

    return (
      <div style={this.styles.menu}>
        {
          this.state.showBlackFriday == true ? (
        <div
          id="blackfriday"
        >
          <i
            id="form_client_close_modal"
            className="fas fa-times-circle color_fa fa-2x"
            style={{position: 'absolute', right: 15, color: '#fff', top: 10, fontSize: 22}}
            onClick={this.closeBlackFriday.bind(this)}
          >{''}</i>

          <div id="bfcontador">
            <span id="dfcontadordias">{this.state.dfcontadordias}</span>
            <span id="dfcontadorhoras">{this.state.dfcontadorhoras}</span>
            <span id="dfcontadormin">{this.state.dfcontadormin}</span>
          </div>
          <img
            id="imgblackfriday"
            src={urlBase.client+'assets/images2/blackfriday/fundo_banner_horizontal.png'}
            onClick={this.setValuePlan.bind(this, '5d76652517185e4be41e6ea3', true, "digital")}
          />
        </div>
          ) : ('')
        }

      {
        this.props.showMenu == false ? (
        <Navbar light expand="md" style={{paddingTop: 0, paddingBottom: 15}}>
          <Link className="logo logo-txt navbar-brand margin_logo"  to="/">&nbsp;</Link>
          <h1 className="title-menu">FAÇA SEU PLANO <span className="title-menu-break">SEM SAIR DE CASA.</span></h1>
        </Navbar>
        ) : (
          // Inclusão do banner do boleto
        
        <div>
   

           <Container id="banner_boleto"> 
                  <div className="banner_boleto_img">
                    {/* 
                      <Row >

                      <Col xs="12" sm="12" md="12" lg="4" xl="2" style={{paddingRight:0, paddingLeft: 0}}></Col>
                             <Col xs="12" sm="12" md="12" lg="6" xl="5" style={{marginTop:25, paddingRight:0, paddingLeft: 0}}>
                                <p className="banner_boleto_text" >Boleto digital aqui, na hora!</p>
                            </Col>
                            <Col xs="12" sm="12" md="12" lg="4" xl="1" style={{paddingRight: 0, paddingLeft: 0}}>
                            { window.innerWidth > 1203 ? 
                            (
                              <Button className="button_emite_boleto" style={{marginTop:25}} href="boletodigital">
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; EMITA AGORA  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              </Button>  
                            ) 
                            : (
                              <Button className="button_emite_boleto"  style={{marginTop:-30}} href="boletodigital">
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; EMITA AGORA &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              </Button>                                
                            ) } 
   
                            </Col>       
    
                                            
                     </Row>
                     */}
                  </div>            
           </Container>  

     
  {/* 
        <div>
           <img src={urlBase.client+'assets/images2/top-banner.png'} />
        </div> 
    */}
        {/** 
        <Navbar light expand="md" style={{paddingTop: 0, paddingBottom: 0}}>
          <Link className="logo navbar-brand margin_logo"  to="/">&nbsp;</Link> 

            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className="ml-auto nav_menu" navbar>

                <NavItem className="margin_item_left">
                      <NavLink href="institucional" style={{ cursor: 'pointer' }}>INSTITUCIONAL</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="redecredenciada">REDE CREDENCIADA</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="carteirinha">CARTEIRINHA</NavLink>
                </NavItem>
               
                
              </Nav>
            </Collapse>
        </Navbar>
        */}
        </div>
        )
      }

        <Dialog
          open={this.state.aboutDentalModalOpen}
          //classNames={{modal: 'modal_payment_slip'}}
          onRequestClose={this.aboutDentalModalClose}
          contentStyle={{width: '90%',maxWidth: '100%',borderRadius: 10,height: '100%'}}
          title={
            <div>
              <div className="logo_modal navbar-brand">&nbsp;</div>
              <i
                id="modal_payment_slip_close_modal"
                className="fas fa-times-circle color_fa"
                onClick={this.aboutDentalModalClose.bind(this)}
              >{''}</i>
              <h2 className="modal_payment_slip_title">DEMONSTRATIVOS FINANCEIROS</h2>
            </div>
          }
        >
          <iframe src={urlBase.client+'assets/pdf/DEMONSTRATIVOS_FINANCEIROS_DENTAL.pdf'} width="100%" height="410">
            &nbsp;
          </iframe>
        </Dialog>
      </div>
    );
  }
}

MenuNew.defaultProps = {
  showMenu: true
};


MenuNew.propTypes = {
  showMenu: PropTypes.bool
};

export default MenuNew;



/** WEBPACK FOOTER **
 ** ./src/components/MenuNew.js
 **/